import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

/**
 * Bu component, bir rotayı korur.
 * Giriş yapılmamışsa /login'e yönlendirir.
 * Rolü yetersizse kullanıcının kendi anasayfasına yönlendirir.
 */
const ProtectedRoute = ({ children, roles }) => {
  const { user, loading } = useAuth()

  // 1. Context, kullanıcıyı kontrol ederken (sayfa yenilendiğinde) bekleme ekranı göster
  if (loading) {
    return (
      <div className="flex justify-center pt-3">
        {/* Tailwind ile basit bir loading halkası */}
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"></div>
      </div>
    )
  }

  // 2. Kullanıcı giriş yapmamışsa (user null ise) login'e yönlendir
  if (!user) {
    return <Navigate to="/auth/sign-in" replace />
  }

  // 3. Rota için 'roles' listesi verilmişse VE kullanıcının rolü bu listede YOKSA
  if (roles && !roles.includes(user.role)) {
    // Kullanıcıyı kendi rolünün anasayfasına yönlendir (veya /404'e)
    return <Navigate to={`/${user.role}/dashboard`} replace />
  }

  // 4. Yetkisi varsa, istenen sayfayı (children) göster
  return children
}

export default ProtectedRoute
